import { observable, reaction, action, computed, runInAction } from "mobx"
import { Step, MembersMapI, BookingFlow } from "../../BookingFlow"
import { BookingDB } from "../../db/BookingLightDB"
import { Member } from "BookingSystem/db/Member"

export class MembersStep implements Step, MembersMapI {
  constructor(db: BookingDB) {
    this.db = db
    this.searchMember = new Member(this.db)
    reaction(
      () => this.quickAddName,
      value => {
        if (value.length && value.indexOf(" ") !== -1) {
          this.searchMember.object.firstName = value.split(" ")[0]
          this.searchMember.object.lastName = value.split(" ")[1]
        }
      }
    )

    reaction(
      () => this.searchMember.uniqueIndex,
      async (uniqueIndex: string) => {
        if (uniqueIndex) {
          this.foundMember = await this.flow.lookupMember(uniqueIndex)
        }
      }
    )
  }

  @observable
  flow: BookingFlow

  has(member: Member) {
    return false
  }

  @observable
  db: BookingDB

  @observable
  isEditable = true

  @computed
  get memberList() {
    return this.flow.currentBooking.members
  }

  @observable
  isSelectable = false

  @observable
  searchMember: Member

  @observable
  name = "Members"

  @computed
  get instruction() {
    const v = this.flow.currentBooking.memberOwner
    if (v && v.object.firstName) {
      return `Welcome ${v.object.firstName}! Who is coming with you?`
    }
    return "Who is coming with you?"
  }

  @observable
  help = "Enter information for all participants and observers"

  @observable
  foundMember: Member | undefined

  @observable
  quickAddName = ""

  @action.bound
  clearInputFields() {
    this.quickAddName = ""
    this.searchMember = new Member(this.db)
    this.foundMember = undefined
  }

  @computed
  get shouldShowMembersEditor() {
    return this.flow.currentBooking.members.length > 0
  }

  @action.bound
  editMember(member: Member, shouldAdd = true) {
    this.flow.editMember(member, () => {
      runInAction(async () => {
        if (member.isValid) {
          try {
            runInAction(() => {
              this.db.save(member)
              if (shouldAdd) {
                this.flow.currentBooking.addMember(member)
                if (member.isMinor && this.flow.currentBooking.memberOwner) {
                  this.flow.currentBooking.memberOwner.addMinor(member)
                  this.db.save(this.flow.currentBooking.memberOwner)
                }
              }
            })
            await this.db.postNextSyncRequest()
          } catch (err) {
            alert("Error saving member")
            console.error(err)
          }
        } else this.editMember(member)
      })
    })
  }

  @action.bound
  editNewMember() {
    let newMember: Member = new Member(this.db)
    this.editMember(newMember)
  }

  @action.bound
  onEdit(member: Member) {
    this.editMember(member, false)
  }

  toggleMembership(member: Member) {
    //Not editable
  }

  @action.bound
  toggleAllMembers() {
    this.memberList.map(member => {
      if (this.flow.currentBooking.members[member.id]) {
        delete this.flow.currentBooking.object.$members[member.id]
      } else {
        this.flow.currentBooking.addMember(member)
      }
    })
  }

  @action.bound
  onDelete(member: Member) {
    if (
      confirm("Are you sure you want to remove this member from you booking?")
    )
      if (member.id) {
        delete this.flow.currentBooking.object.$members[member.id]
      }
  }
}
